module.exports = __webpack_public_path__ + "img/dj.11ed5ee3.svg";